import Vapi from '@borisp/vuex-rest-api'
import { payloadToState } from '../../utils/helpers'
import { VUE_APP_BASE_API_URL } from '../../constants/fileConstants'

export const EPGS_SET_EPG_SHOW = 'EPGS_SET_EPG_SHOW'

const storeApi = new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    epgs: [],
    epgsMetadata: {},
    epg: {},
    epgMetadata: {},
    broadcastAssign: {}
  }
})
  .get({
    queryParams: true,
    action: 'getEpgs',
    property: 'epgs',
    path: '/broadcasts/',
    onSuccess: payloadToState('epgs')
  })
  .get({
    action: 'getEpg',
    property: 'epg',
    queryParams: true,
    path: ({ id }) => `/broadcasts/${id}`,
    onSuccess: payloadToState('epg')
  })
  .put({
    action: 'assignBroadcasts',
    property: 'broadcastAssign',
    path: '/broadcasts/assignments',
    onSuccess: payloadToState('broadcastAssign')
  })
  .getStore()

export default {
  ...storeApi,
  mutations: {
    ...storeApi.mutations,
    [EPGS_SET_EPG_SHOW](state, { show }) {
      state.epg.show = show
    }
  }
}
